// Client-safe environment values (NEXT_PUBLIC only) for browser/edge usage.
const withDefault = (value: string | undefined, fallback: string) => value ?? fallback;

export const clientEnv = {
  NEXT_PUBLIC_API_URL: withDefault(process.env.NEXT_PUBLIC_API_URL, "http://localhost:3000"),
  NEXT_PUBLIC_APP_ENV: withDefault(process.env.NEXT_PUBLIC_APP_ENV, "development"),
  NEXT_PUBLIC_APP_TITLE: withDefault(process.env.NEXT_PUBLIC_APP_TITLE, "JFIT"),
  NEXT_PUBLIC_APP_NAME: withDefault(process.env.NEXT_PUBLIC_APP_NAME, "JFIT"),
  NEXT_PUBLIC_APP_URL: withDefault(process.env.NEXT_PUBLIC_APP_URL, "http://localhost:3003"),
  NEXT_PUBLIC_APP_DESCRIPTION: withDefault(
    process.env.NEXT_PUBLIC_APP_DESCRIPTION,
    "JFIT is a platform for fitness professionals to manage their clients and bookings.",
  ),
  NEXT_PUBLIC_APP_CATEGORY: withDefault(process.env.NEXT_PUBLIC_APP_CATEGORY, "app"),
  NEXT_PUBLIC_APP_KEYWORDS: withDefault(
    process.env.NEXT_PUBLIC_APP_KEYWORDS,
    "jfit, fitness, booking, management, platform",
  ),
  NEXT_PUBLIC_GTM_KEY: process.env.NEXT_PUBLIC_GTM_KEY,
  NEXT_PUBLIC_POSTHOG_KEY: process.env.NEXT_PUBLIC_POSTHOG_KEY,
  NEXT_PUBLIC_POSTHOG_HOST: withDefault(
    process.env.NEXT_PUBLIC_POSTHOG_HOST,
    "https://eu.i.posthog.com",
  ),
  NEXT_PUBLIC_POSTHOG_INGEST: withDefault(process.env.NEXT_PUBLIC_POSTHOG_INGEST, "/ingest"),
  NEXT_PUBLIC_POSTHOG_ENVIRONMENT: withDefault(
    process.env.NEXT_PUBLIC_POSTHOG_ENVIRONMENT,
    "development",
  ),
} as const;
